var map = {
	"./american-football-image.png": 5359,
	"./basketball-image.png": 8738,
	"./football-image.png": 3228,
	"./golf-image.png": 3539,
	"./tennis-image.png": 2494,
	"./volleyball-image.png": 4655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6797;